import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=bff03576&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=js&"
export * from "./Dropdown.vue?vue&type=script&lang=js&"
import style0 from "./Style/dropdown.scss?vue&type=style&index=0&id=bff03576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff03576",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff03576')) {
      api.createRecord('bff03576', component.options)
    } else {
      api.reload('bff03576', component.options)
    }
    module.hot.accept("./Dropdown.vue?vue&type=template&id=bff03576&scoped=true&", function () {
      api.rerender('bff03576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Inputs/Dropdown.vue"
export default component.exports